module.exports = __webpack_public_path__ + "img/world-map.1bd67733.svg";